<style lang="less" scoped>
</style>
<template>
  <div>
    <div class="content">
      <Header ref="header"></Header>
      <guide></guide>
      <ComFooter></ComFooter>
    </div>
  </div>
</template>
<script>
import Header from "@/components/comHeader.vue";
import guide from "@/components/guide.vue";
import ComFooter from "@/components/footer.vue";

export default {
  components: {
    ComFooter,
    Header,
    guide,
  },
  data() {
    return {
      title: this.$t("guide.guide20"),
    };
  },
  watch: {},
  mounted() {
     this.$refs.header.title = this.title;
  },
  methods: {},
};
</script>